import { render, staticRenderFns } from "./CalendarControlWaitingRoom.vue?vue&type=template&id=5a840cde&scoped=true"
import script from "./CalendarControlWaitingRoom.vue?vue&type=script&lang=js"
export * from "./CalendarControlWaitingRoom.vue?vue&type=script&lang=js"
import style0 from "./CalendarControlWaitingRoom.vue?vue&type=style&index=0&id=5a840cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a840cde",
  null
  
)

export default component.exports